var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"#333"},attrs:{"dark":"","id":"app"}},[_c('router-view'),_c('ModalConfirmAction'),_c('ModalLoading'),_c('ModalGlobalMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }